<script>
import { MapAgentStationStatus, MapRoles } from "@/common/util";
import PagenationContainer from "@/components/common/PagenationContainer.vue";

import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";
import moment from "moment";
export default {
  components: {
    PagenationContainer
  },
  data() {
    const ROLE_SUPER_ADMIN =
      localStorage.getItem("roles").indexOf("ROLE_SUPER_ADMIN") > -1;
    const ROLE_AGENT =
      localStorage.getItem("roles").indexOf("ROLE_AGENT") > -1 &&
      !(localStorage.getItem("roles").indexOf("ROLE_AGENT_OPTOMETRIST") > -1);
    const ROLE_REGION_MANAGER =
      localStorage.getItem("roles").indexOf("ROLE_REGION_MANAGER") > -1;
    const ROLE_STATION_MANAGER =
      localStorage.getItem("roles").indexOf("ROLE_STATION_MANAGER") > -1;
    // sessionStorage.clear();

    var tmpSearchForm = {
      stationId: undefined,
      stationName: undefined,
      provinceCity: undefined
    };
    var s = sessionStorage.getItem("institutionAnalysisSearchForm");
    if (s) {
      tmpSearchForm = JSON.parse(s);
      // 多选 cascader 的值为路径数组 [[pid],[pid,cid],...]，兼容旧版单选格式 [pid,cid]
      if (
        Array.isArray(tmpSearchForm.provinceCity) &&
        tmpSearchForm.provinceCity.length > 0 &&
        !Array.isArray(tmpSearchForm.provinceCity[0])
      ) {
        tmpSearchForm.provinceCity = [tmpSearchForm.provinceCity];
      }
    }

    var tmpDateRange = undefined;
    var d = sessionStorage.getItem("institutionAnalysisDateRange");
    if (d) {
      tmpDateRange = JSON.parse(d);
    }

    var tmpPage = 1;
    var p = sessionStorage.getItem("institutionAnalysisPage");
    if (p) {
      tmpPage = JSON.parse(p);
    }

    return {
      ROLE_SUPER_ADMIN: ROLE_SUPER_ADMIN,
      ROLE_AGENT: ROLE_AGENT,
      ROLE_REGION_MANAGER: ROLE_REGION_MANAGER,
      ROLE_STATION_MANAGER: ROLE_STATION_MANAGER,
      analysisMode:
        sessionStorage.getItem("institutionAnalysisMode") || "someMonths",
      searchFormData: tmpSearchForm,
      tableData: [
        {
          stationName: "",
          someDaysSales: [],
          someMonthsSales: [],
          totalSalesCourse: 0,
          totalSalesAmount: 0
        }
      ],
      searchArray: [
        {
          label: "省市搜索",
          keyName: "provinceCity",
          value: tmpSearchForm.provinceCity,
          children: [],
          type: "cascader",
          props: { multiple: true, checkStrictly: false }
        },
        {
          label: "机构名称",
          keyName: "stationName",
          value: tmpSearchForm.stationName,
          type: "text"
        }
      ],
      defaultValue: {},
      agentList: [],
      pageCount: 0,
      activePage: tmpPage,
      totalElements: 0,
      dateRange: tmpDateRange,
      buttonArray: [
        {
          text: "昨天",
          key: "yesterday"
        },
        {
          text: "最近一周",
          key: "week"
        },
        {
          text: "最近30天",
          key: "month"
        },
        {
          text: "最近90天",
          key: "ninety"
        }
      ]
    };
  },
  created() {
    if (!this.ROLE_STATION_MANAGER) {
      this.loadProvice();
    } else {
      this.searchArray = [this.searchArray[1]];
    }

    this.loadData();
  },
  methods: {
    async loadData() {
      let params = {
        page: this.activePage - 1,
        size: 20
      };
      for (let key in this.searchFormData) {
        if (key === "provinceCity") {
          if (this.searchFormData[key]) {
            // cascader 多选模式下 value 为路径数组，如 [[pid], [pid, cid], ...]
            // 兼容旧版单选格式 [pid, cid]（扁平数组），统一包装为路径数组
            let paths = this.searchFormData[key];
            if (paths.length > 0 && !Array.isArray(paths[0])) {
              paths = [paths];
            }
            const provinceIds = [];
            const cityIds = [];
            paths.forEach(path => {
              if (Array.isArray(path) && path.length === 1 && path[0]) {
                provinceIds.push(path[0]);
              } else if (Array.isArray(path) && path.length >= 2 && path[1]) {
                cityIds.push(path[1]);
              }
            });
            if (provinceIds.length > 0) {
              params.provinceIds = provinceIds;
            }
            if (cityIds.length > 0) {
              params.cityIds = cityIds;
            }
          }
        } else if (this.searchFormData[key]) {
          params[key] = this.searchFormData[key];
        }
      }

      if (this.analysisMode === "anyRange") {
        if (this.dateRange && this.dateRange[0]) {
          params.start = this.dateRange[0];
        }
        if (this.dateRange && this.dateRange[1]) {
          params.end = this.dateRange[1];
        }
      }

      sessionStorage.setItem("institutionAnalysisMode", this.analysisMode);
      sessionStorage.setItem(
        "institutionAnalysisPage",
        JSON.stringify(this.activePage)
      );
      if (this.dateRange) {
        sessionStorage.setItem(
          "institutionAnalysisDateRange",
          JSON.stringify(this.dateRange)
        );
      }
      sessionStorage.setItem(
        "institutionAnalysisSearchForm",
        JSON.stringify(this.searchFormData)
      );

      if (this.analysisMode === "someMonths") {
        params.showNumber = 18;
        const result = await this.$http.GetStationSalesPerformanceLastMonths(
          params
        );

        if (result && result.content) {
          this.pageCount = result.totalPages;
          this.totalElements = result.totalElements;

          // 最近数月销量
          const tableData = result.content.map(item => {
            let someMonthsSales = "";
            if (item.yearSales && item.yearSales.length > 0) {
              item.yearSales.forEach((o, index) => {
                if (index + 1 === item.yearSales.length) {
                  someMonthsSales +=
                    this.fourDigitForPositiveNumber(o.count) + "(当月)";
                } else {
                  someMonthsSales += this.fourDigitForPositiveNumber(o.count);
                }
              });
            }
            item.someMonthsSales = someMonthsSales;
            return item;
          });

          this.tableData = tableData;
        }
      } else if (this.analysisMode === "someDays") {
        params.showNumber = 21;
        const result = await this.$http.GetStationSalesPerformanceLastDays(
          params
        );

        if (result && result.content) {
          this.pageCount = result.totalPages;
          this.totalElements = result.totalElements;

          // 最近数天销量
          const tableData = result.content.map(item => {
            let someDaysSales = "";
            if (item.monthSales && item.monthSales.length > 0) {
              item.monthSales.forEach((o, index) => {
                if (index + 1 === item.monthSales.length) {
                  someDaysSales +=
                    this.fourDigitForPositiveNumber(o.count) + "(今日)";
                } else {
                  someDaysSales += this.fourDigitForPositiveNumber(o.count);
                }
              });
            }
            item.someDaysSales = someDaysSales;
            return item;
          });

          this.tableData = tableData;
        }
      } else if (this.analysisMode === "anyRange") {
        const result = await this.$http.GetStationSalesPerformance(params);

        if (result && result.content) {
          this.pageCount = result.totalPages;
          this.totalElements = result.totalElements;

          const tableData = result.content.map(item => {
            return item;
          });

          this.tableData = tableData;
        }
      }
    },
    async loadProvice() {
      let ProvinceList = [];
      let province = [];

      if (this.ROLE_AGENT) {
        ProvinceList = await this.$http.getProvinceList("agent");
        province = this.searchArray;
      } else if (this.ROLE_SUPER_ADMIN) {
        ProvinceList = await this.$http.getProvinceList("superAdmin");
        province = this.searchArray;
      } else if (this.ROLE_REGION_MANAGER) {
        ProvinceList = await this.$http.getProvinceList("regionManager");
        province = this.searchArray;
      }
      if (ProvinceList.length > 0) {
        const provinceChildren = ProvinceList.map(o => {
          return {
            label: o.name,
            keyName: o.id,
            value: o.id,
            children: o.sons.map(o => {
              return {
                label: o.name,
                value: o.id
              };
            }),
            id: o.id,
            name: o.name
          };
        });
        province.forEach(o => {
          if (o.keyName === "provinceCity") {
            o.children = provinceChildren;
          }
        });
        this.ProvinceList = provinceChildren;
      }
    },
    fourDigitForPositiveNumber(num) {
      if (num < 10) {
        return "   " + num;
      } else if (num < 100) {
        return "  " + num;
      } else {
        return " " + num;
      }
    },
    onSearch(data) {
      this.activePage = 1;
      this.loadData();
    },
    onSearchChange(data) {
      this.searchFormData = data;
    },
    onAnalysisModeChange(mode) {
      this.activePage = 1;
      this.loadData();
    },
    onClick(row) {
      this.$router.push({
        path: `${this.$route.path}/institutionsDetail/${row.stationUUID}`
      });
    },
    handleCurrentChange(val) {
      this.activePage = val;
      this.loadData();
    },
    onOperationClick(row, key) {
      console.log("key", key);
      switch (key) {
        case "yesterday":
          this.dateRange = [
            moment()
              .subtract(1, "days")
              .format("YYYY-MM-DD"),
            moment().subtract(1, "days").format("YYYY-MM-DD")
          ];
          break;
        case "month":
          this.dateRange = [
            moment()
              .subtract(30, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
        case "ninety":
          this.dateRange = [
            moment()
              .subtract(90, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
        case "week":
          this.dateRange = [
            moment()
              .subtract(6, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
      }
      console.log("key", this.dateRange);
    }
  }
};
</script>
<template>
  <div class="salesManagemmentIndex">
    <div class="analysisModeSelection">
      <el-radio-group v-model="analysisMode" @change="onAnalysisModeChange">
        <el-radio-button label="someMonths">最近 18 个月总览</el-radio-button>
        <el-radio-button label="someDays">最近 21 天总览</el-radio-button>
        <el-radio-button label="anyRange">任意时间区间研判</el-radio-button>
      </el-radio-group>
    </div>
    <searchFormNew
      class="searchForm"
      showSearch
      @onSearch="onSearch"
      @onChange="onSearchChange"
      :searchItemArray="searchArray"
    />
    <div class="TextGroup" v-if="analysisMode === 'anyRange'">
      <div class="dataSearch">
        <span>销售疗程时间筛选：</span>
        <el-date-picker
          v-model="dateRange"
          size="medium"
          class="dateRange"
          type="daterange"
          range-separator="至"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <textButtonGroup
          class="dataButton"
          :buttonArray="buttonArray"
          @onOperationClick="onOperationClick"
        />
      </div>
    </div>
    <div class="statistics">
      <i class="el-icon-info totalResult"></i>
      查询结果：
      <span class="totalResult">{{totalElements}}</span> 个
    </div>
    <el-table
      :data="tableData"
      class="refundTable"
      @row-click="onClick"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="stationName" align="left" label="机构名称" min-width="100"></el-table-column>
      <el-table-column
        prop="totalSalesCourse"
        align="left"
        label="销售总疗程"
        min-width="150"
        v-if="analysisMode === 'anyRange'"
      ></el-table-column>
      <el-table-column
        prop="totalSalesAmount"
        align="left"
        label="销售总金额"
        min-width="150"
        v-if="analysisMode == 'anyRange'"
      ></el-table-column>

      <el-table-column
        prop="someMonthsSales"
        align="left"
        label="最近 18 个月销售疗程"
        min-width="500"
        v-if="analysisMode === 'someMonths'"
      ></el-table-column>

      <el-table-column
        prop="someDaysSales"
        align="left"
        label="最近 21 天销售疗程"
        min-width="500"
        v-if="analysisMode === 'someDays'"
      ></el-table-column>
    </el-table>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.salesManagemmentIndex {
  .analysisModeSelection {
    padding-left: 15px;
    padding-top: 12px;
  }
  .searchForm {
    border: 1px;
    line-height: 50px;
    padding-top: 15px;
    margin: 0 1%;
  }
  .statistics {
    float: right;
    margin-right: 30px;
    margin-top: 20px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
    .totalResult {
      color: #00c1de;
    }
  }
  .TextGroup {
    margin: 0 20px 0px;
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
    color: #606266;
    .dateRange {
      width: 250px;

      .el-range-editor--mini.el-input__inner {
        height: 32px;
      }

      .el-range-editor.is-active,
      .el-range-editor.is-active:hover {
        border-color: #00c1de;
      }

      .el-date-table td.today span {
        color: #00c1de;
      }
    }
    .dataButton {
      margin-left: 10px;
      display: inline-block;
    }
  }
  .refundTable {
    margin: 20px 1%;
    border: 1px;
    width: 98%;

    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    th > .cell {
      font-weight: bold;
    }

    .cell {
      white-space: pre;
      font-family: monospace;
    }

    .cellButtonGroup {
      background-color: #00c1de;
      border-color: #00c1de;
      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/salesManagement/institutionsList.vue